module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.13315/img/templates-homepage/homepage-icon.svg"